import { render, staticRenderFns } from "./SchemaInspectionFloatingButton.vue?vue&type=template&id=55c7e64c&scoped=true"
import script from "./SchemaInspectionFloatingButton.vue?vue&type=script&lang=js"
export * from "./SchemaInspectionFloatingButton.vue?vue&type=script&lang=js"
import style0 from "./SchemaInspectionFloatingButton.vue?vue&type=style&index=0&id=55c7e64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c7e64c",
  null
  
)

export default component.exports